import { AmIcon, PmIcon } from '@/components/DriverManagement/Manage/TemplateManagement/ShiftTiles/ShiftIcons'
import { useApiClient } from '@/hooks/useApiClient'
import { PlusOutlined } from '@ant-design/icons'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { Dropdown } from 'antd'
import { type PropsWithChildren, useMemo } from 'react'

type NewEventDropdownProps = PropsWithChildren<{
  onSelect: (item: string) => void
  isCarrier: boolean
  shiftPreference?: string | null
  hideAmPm?: boolean
}>

export const NewEventDropdown = ({
  children,
  onSelect,
  isCarrier,
  shiftPreference,
  hideAmPm,
}: NewEventDropdownProps) => {
  const api = useApiClient()
  const { data: specialPayTypes } = api.useQuery('post', '/payroll/special_pay/list_scheduled', undefined, {
    staleTime: 60_000,
  })

  const items = useMemo(() => {
    const childItems = (specialPayTypes as { name: string }[] | undefined)?.map(({ name }) => ({
      key: name,
      label: name,
      onClick: () => onSelect(name),
    }))
    if (hideAmPm) return childItems
    return [
      {
        key: 'add-shift',
        disabled: true,
        icon: <PlusOutlined />,
        label: (
          <Texto appearance='hint' category='p2'>
            Add To Slot
          </Texto>
        ),
      },
      {
        key: 'am-shift',
        icon: <AmIcon />,
        label: <Texto category='p2'>AM Shift{shiftPreference === 'am' ? ' (Default)' : undefined}</Texto>,
        onClick: () => onSelect('AM Shift'),
      },
      {
        key: 'pm-shift',
        icon: <PmIcon />,
        label: <Texto category='p2'>PM Shift{shiftPreference === 'pm' ? ' (Default)' : undefined}</Texto>,
        onClick: () => onSelect('PM Shift'),
      },
      !isCarrier
        ? {
            key: 'special-event',
            label: 'Special Event',
            children: childItems,
          }
        : null,
    ]
  }, [specialPayTypes, isCarrier, hideAmPm, shiftPreference, onSelect])

  if (hideAmPm && isCarrier) return null

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      {children ?? <GraviButton size='small' icon={<PlusOutlined />} />}
    </Dropdown>
  )
}
